<template>
    <a-drawer :maskClosable="false" class="project-create" @close="close" :visible.sync="visible" width="650px">
        <div class="wrapper">
            <div class="at-title">
                <div class="at-title-create"></div>
            </div>
            <div class="tearcher-list" v-show="showTeacherList">
                <div class="container">
                    <div class="tearcher-items">
                        <div class="tearcher-item" v-for="teacher in teachers" :key="teacher.id"
                            @click="selectTeacher(teacher)">
                            <div class="checkbox-container">
                                <img v-if="isTeacherSelected(teacher)" src="/assets/icons/icon-active-teacher.png"
                                    class="checkbox-checked" />
                                <div v-else class="checkbox-unchecked"></div>
                            </div>
                            <img class="avatar" :src="teacher.avatar" :alt="teacher.name" />
                            <span>{{ teacher.name }}</span>
                        </div>
                    </div>
                    <div class="buttons-container">
                        <button @click="confirmTeacherSelection" class="btn">确定</button>
                        <button @click.stop="closeTeacherList" class="btn-close">关闭</button>
                    </div>
                </div>
            </div>
            <perfect-scrollbar class="body-scroll" :options="{ suppressScrollX: false }">

                <div class="item">
                    <div class="sub-title">
                        <span>*</span>
                        <span>项目名称</span>
                    </div>

                    <div class="content-wrapper">
                        <input type="text" class="input" maxLength="10" v-model="params.name"
                            placeholder="请输入不超过10字的名称" />
                        <div class="input-length">{{ params.name.length }}/10</div>
                    </div>
                </div>

                <div class="item">
                    <div class="sub-title">
                        <span>*</span>
                        <span>预约模式</span>
                    </div>

                    <div class="content-wrapper">
                        <div class="radio-item">
                            <a-radio-group v-model="params.type" size="small">
                                <a-radio value="flexible">随用随约</a-radio>
                                <a-radio value="fixed">固定班次</a-radio>
                            </a-radio-group>
                        </div>
                    </div>
                </div>

                <!-- 随用随约 -->
                <div class="item" v-if="params.type === 'flexible'">
                    <div class="sub-title">
                        <span></span>
                        <span>项目老师</span>
                    </div>
                    <div class="flexible-teacher-box">
                        <!-- 显示已选择的老师 -->
                        <div class="selected-teachers" v-if="flexibleTeachers.length > 0">
                            <div class="selected-teacher-item" v-for="teacher in flexibleTeachers" :key="teacher.id">
                                <div class="teacher-info">
                                    <img :src="teacher.avatar" :alt="teacher.name" />
                                    <span>{{ teacher.name }}</span>
                                </div>
                                <div class="del-box" @click.stop="removeFlexibleTeacher(teacher)">
                                    <img src="/assets/icons/input-del.png" />
                                </div>
                            </div>
                        </div>
                        <!-- 添加老师按钮 -->
                        <div class="add-box" @click="selectFlexibleTeachers">
                            <img src="/assets/icons/icon-add-project.png" />
                            <span>添加人员</span>
                        </div>
                    </div>

                    <div class="sub-title">
                        <span></span>
                        <span>项目单次时长(分钟)</span>
                    </div>
                    <div class="content-wrapper" style="margin-bottom: 24px;">
                        <input type="number" class="input" v-model="params.duration" placeholder="请输入" />
                    </div>

                    <div class="sub-title">
                        <span></span>
                        <span>每日可预约开放时间段</span>
                    </div>
                    <div class="time-wrapper">
                        <a-table :data-source="available_times" size="small" :pagination="false"
                            :rowKey="(record, index) => index" bordered>
                            <a-table-column title="每日可预约开始时间" align="center" dataIndex="start_time">
                                <template slot-scope="val,record">
                                    <a-time-picker :open.sync="record.startOpen"
                                        :default-value="moment(record.start_time, 'HH:mm')" format="HH:mm"
                                        @change="handleStartTimeChange(record, $event)">
                                        <a-button slot="addon" size="small" type="primary"
                                            @click="record.startOpen = false">
                                            确定
                                        </a-button>
                                    </a-time-picker>
                                </template>
                            </a-table-column>
                            <a-table-column title="每日可预约结束时间" align="center" dataIndex="end_time">
                                <template slot-scope="val,record">
                                    <a-time-picker :open.sync="record.endOpen"
                                        :default-value="moment(record.end_time, 'HH:mm')" format="HH:mm"
                                        @change="handleEndTimeChange(record, $event)">
                                        <a-button slot="addon" size="small" type="primary"
                                            @click="record.endOpen = false">
                                            确定
                                        </a-button>
                                    </a-time-picker>
                                </template>
                            </a-table-column>
                            <a-table-column title="操作" align="center" width="80">
                                <template slot-scope="val,record,index">
                                    <div class="del-box" @click.stop="removeAvailableTime(index)">
                                        <img src="/assets/icons/input-del.png" style="width: 24px; height: 24px;" />
                                    </div>
                                </template>
                            </a-table-column>
                        </a-table>
                        <div class="add-box" style="border-top:none;" @click="addAvailableTime">
                            <img src="/assets/icons/icon-add-project.png" />
                            <span>新增开放时间段</span>
                        </div>
                    </div>

                    <div class="sub-title">
                        <span></span>
                        <span>不可预约时间设置</span>
                    </div>
                    <div class="unavailable-wrapper">
                        <div class="unavailable-row">
                            <div class="checkbox-item" @click="handleCheckboxChange('saturday_unavailable')">
                                <div class="checkbox-icon">
                                    <img src="/assets/icons/icon-checked.png" v-if="saturday_unavailable" />
                                    <img src="/assets/icons/icon-unchecked.png" v-else />
                                </div>
                                <span>周六</span>
                            </div>
                            <div class="checkbox-item" @click="handleCheckboxChange('sunday_unavailable')">
                                <div class="checkbox-icon">
                                    <img src="/assets/icons/icon-checked.png" v-if="sunday_unavailable" />
                                    <img src="/assets/icons/icon-unchecked.png" v-else />
                                </div>
                                <span>周日</span>
                            </div>
                            <!-- <div class="checkbox-item" @click="handleCheckboxChange('holiday_unavailable')">
                                <div class="checkbox-icon">
                                    <img src="/assets/icons/icon-checked.png" v-if="holiday_unavailable" />
                                    <img src="/assets/icons/icon-unchecked.png" v-else />
                                </div>
                                <span>法定节假日</span>
                            </div> -->
                        </div>
                    </div>
                    
                    <!-- 显示已添加的不可预约时间段 -->
                    <div v-if="unavailable_times.length > 0" class="unavailable-time-list">
                        <a-table :data-source="unavailable_times" size="small" :pagination="false"
                            :rowKey="(record, index) => index" bordered>
                            <a-table-column title="开始日期" align="center">
                                <template slot-scope="val,record">
                                    <a-date-picker v-model="record.start_date" placeholder="选择日期" format="YYYY-MM-DD" style="width: 120px;" />
                                </template>
                            </a-table-column>
                            <a-table-column title="开始时间" align="center" size="small">
                                <template slot-scope="val,record">
                                    <a-time-picker :open.sync="record.startOpen"
                                        :default-value="moment(record.start_time, 'HH:mm')" format="HH:mm"
                                        @change="handleUnavailableStartTimeChange(record, $event)" style="width: 80px;">
                                        <a-button slot="addon" size="small" type="primary"
                                            @click="record.startOpen = false">
                                            确定
                                        </a-button>
                                    </a-time-picker>
                                </template>
                            </a-table-column>
                            <a-table-column title="结束日期" align="center">
                                <template slot-scope="val,record">
                                    <a-date-picker v-model="record.end_date" placeholder="选择日期" format="YYYY-MM-DD" style="width: 120px;" />
                                </template>
                            </a-table-column>
                            <a-table-column title="结束时间" align="center">
                                <template slot-scope="val,record">
                                    <a-time-picker :open.sync="record.endOpen"
                                        :default-value="moment(record.end_time, 'HH:mm')" format="HH:mm"
                                        @change="handleUnavailableEndTimeChange(record, $event)" style="width: 80px;">
                                        <a-button slot="addon" size="small" type="primary"
                                            @click="record.endOpen = false">
                                            确定
                                        </a-button>
                                    </a-time-picker>
                                </template>
                            </a-table-column>
                            <a-table-column title="操作" align="center" width="80">
                                <template slot-scope="val,record,index">
                                    <div class="del-box" @click.stop="removeUnavailableTime(index)">
                                        <img src="/assets/icons/input-del.png" />
                                    </div>
                                </template>
                            </a-table-column>
                        </a-table>
                        <!-- 格式化显示的不可预约时间段 -->
                        <div v-if="unavailable_times.length > 0" class="formatted-unavailable-times">
                            <div class="unavailable-time-items">
                                <div v-for="(item, index) in unavailable_times" :key="index" class="unavailable-time-item">
                                    <span>{{ formatUnavailableTime(item) }}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    
                    <div class="add-box" @click="addUnavailableTime">
                        <img src="/assets/icons/icon-add-project.png" />
                        <span>新增不可预约时间</span>
                    </div>
                </div>

                <!-- 固定班次 -->
                <div class="item" v-if="params.type === 'fixed'">
                    <div class="sub-title">
                        <span></span>
                        <span>固定班次计划</span>
                    </div>

                    <div class="table-wrapper">
                        <a-table :data-source="table.data" size="small" :pagination="false"
                            :rowKey="(record, index) => index" bordered>

                            <a-table-column title="序号" align="center" width="44px">
                                <template slot-scope="val">
                                    {{ val.index + 1 }}
                                </template>
                            </a-table-column>
                            <a-table-column title="班次计划日期" align="center" width="200px">
                                <template slot-scope="val,record">
                                    <div class="option-box date-box">
                                        <a-date-picker v-model="record.date" placeholder="选择日期" format="YYYY-MM-DD" style="flex: 1; min-width: 100px;" />
                                        <a-time-picker :open.sync="record.openTime" v-model="record.time" style="max-width: 80px;"
                                            :default-value="moment('10:00', 'HH:mm')" format="HH:mm">
                                            <a-button slot="addon" size="small" type="primary" @click.stop="record.openTime = false">
                                                确定
                                            </a-button>
                                        </a-time-picker>
                                    </div>
                                </template>
                            </a-table-column>
                            <a-table-column title="班次老师" align="center" width="108px">

                                <template slot-scope="val">
                                    <div class="option-box teacher-box" @click.stop="showTeacherSelect(val)">
                                        <div class="content">
                                            <div class="teacher-avatars" v-if="val.teachers && val.teachers.length > 0">
                                                <div class="avatar-container"
                                                    :style="{ transform: `translateX(-${Math.min(i * 6, 24)}px)` }"
                                                    v-for="(teacher, i) in val.teachers.slice(0, 5)" :key="teacher.id">
                                                    <img :src="teacher.avatar" :alt="teacher.name" />
                                                </div>
                                            </div>
                                            <span v-else>请选择</span>
                                        </div>
                                        <img src="/assets/icons/icon-select-teacher.png" />
                                    </div>
                                </template>
                            </a-table-column>
                            <a-table-column title="时长(分)" align="center" width="60px">
                                <template slot-scope="val">
                                    <input type="text" class="input" v-model="val.duration" placeholder="请输入" />
                                </template>
                            </a-table-column>
                            <a-table-column title="人数" align="center" width="50px">
                                <template slot-scope="val">
                                    <input type="text" class="input" v-model="val.people" placeholder="请输入" />
                                </template>
                            </a-table-column>
                            <a-table-column title="操作" align="center" width="50px">
                                <template slot-scope="val">
                                    <img src="/assets/icons/input-del.png" 
                                        style="width: 24px; height: 24px; cursor: pointer;" 
                                        @click.stop="removeRow(val.index)" 
                                    />
                                </template>
                            </a-table-column>
                        </a-table>
                        <div class="add-box" @click="addRow">
                            <img src="/assets/icons/icon-add-project.png" />
                            <span>新增班次</span>
                        </div>
                    </div>
                </div>

            </perfect-scrollbar>
            <div class="sd-footer">
                <button class="btn" @click="save">保存</button>
            </div>
        </div>
    </a-drawer>
</template>

<script>
import moment from 'moment';
import api from '@/repo/api';
export default {
    name: 'ProjectCreate',
    data() {
            return {
                visible: false,
                showTeacherList: false,
                currentRow: null,
                teachers: [],
                // 临时存储当前选择的老师
                tempSelectedTeachers: [],
                // 随用随约模式下选择的老师
                flexibleTeachers: [],
                params: {
                    name: '',
                    type: 'flexible',
                },
                openTime: false,
                available_times: [ // 开放时间段
                    {
                        start_time: '09:00',
                        end_time: '18:00',
                        startOpen: false,
                        endOpen: false
                    }
                ],
                unavailable_times: [], // 不可预约时间段
                saturday_unavailable: false, // 周六不可预约
                sunday_unavailable: false, // 周日不可预约
                holiday_unavailable: false, // 节假日不可预约
                isEditMode: false, // 是否为编辑模式
                editRecordId: null, // 编辑的记录ID
            table: {

                data: [
                    {
                        index: '0',
                        date: null,
                        time: null, // 添加time属性的初始化
                        teachers: [],
                        duration: '',
                        people: '',
                        openTime: false // 每个班次独立的时间选择器状态
                    },
                ],
                pagination: {
                    total: 0,
                    current: 1,
                    pageSize: 10,
                },
                dateCurrent: 0,
            },
        }
    },
    mounted() {
        this.getTeachers();
    },
    methods: {
        moment,
        addRow() {
            this.table.data.push({
                index: this.table.data.length,
                date: '',
                time: '', // 添加time属性的初始化
                teachers: [],
                duration: '',
                people: '',
                openTime: false // 每个班次独立的时间选择器状态
            })
        },
        
        // 删除固定班次行
        removeRow(index) {
            // 确保至少保留一行数据
            if (this.table.data.length > 1) {
                // 如果是编辑模式且该行有老师信息，调用验证接口
                const row = this.table.data[index];
                console.log('row',row);
                if (this.isEditMode && this.editRecordId && row.teachers && row.teachers.length > 0) {
                    // 调用验证接口
                    api.post('/ast-appointment/schedule-delete-check', { id: row.id }).then(res => {
                        if (res.code === 0) {
                            if (!res.data.can_delete) {
                                this.$message.error('该班次已被预约，无法删除');
                                return;
                            }
                            // 验证通过，执行删除
                            this.performRemoveRow(index);
                        } else {
                            this.$message.error(res.msg || '验证失败，无法删除班次');
                        }
                    }).catch(() => {
                        this.$message.error('验证接口网络异常，请重试');
                    });
                } else {
                    // 非编辑模式或无老师信息，直接删除
                    this.performRemoveRow(index);
                }
            } else {
                this.$message.warning('至少需要保留一个班次');
            }
        },
        // 执行删除固定班次行的操作
        performRemoveRow(index) {
            this.table.data.splice(index, 1);
            // 重新计算索引
            this.table.data.forEach((item, idx) => {
                item.index = idx;
            });
        },

        addAvailableTime() {
            this.available_times.push({
                start_time: '09:00',
                end_time: '18:00',
                startOpen: false,
                endOpen: false
            })
        },
        handleStartTimeChange(item, time) {
            if (time) {
                item.start_time = time.format('HH:mm');
            }
        },
        handleEndTimeChange(item, time) {
            if (time) {
                item.end_time = time.format('HH:mm');
            }
        },
        open(record) {
            this.visible = true;
            // 如果传入了记录，表示编辑模式，需要加载数据
            if (record) {
                this.isEditMode = true;
                this.editRecordId = record.id;
                this.loadProjectData(record);
            } else {
                this.isEditMode = false;
                this.editRecordId = null;
                this.resetForm();
            }
        },
        
        // 加载项目数据
        loadProjectData(record) {
            // 重置表单
            this.resetForm();
            
            // 填充基本信息
            this.params = {
                name: record.name || '',
                type: record.type || 'flexible'
            };
            
            // 如果有随用随约老师信息
            if (record.type === 'flexible' && record.teachers && record.teachers.length > 0) {
                this.flexibleTeachers = record.teachers;
            }
            
            // 填充随用随约模式的其他信息
            if (record.type === 'flexible') {
                this.params.duration = record.duration || '';
                // 检查available_times格式，如果是二维数组则转换为对象数组格式
                if (record.available_times && Array.isArray(record.available_times)) {
                    if (record.available_times.length > 0 && Array.isArray(record.available_times[0])) {
                        // 如果是二维数组格式 [[start, end], [start, end]]
                        this.available_times = record.available_times.map(timeRange => ({
                            start_time: timeRange[0] || '09:00',
                            end_time: timeRange[1] || '18:00',
                            startOpen: false,
                            endOpen: false
                        }));
                    } else {
                        // 如果是对象数组格式 [{start_time, end_time}] 或为空
                        this.available_times = record.available_times || [{ start_time: '09:00', end_time: '18:00', startOpen: false, endOpen: false }];
                    }
                } else {
                    this.available_times = [{ start_time: '09:00', end_time: '18:00', startOpen: false, endOpen: false }];
                }
                this.saturday_unavailable = record.saturday_unavailable === 1;
                this.sunday_unavailable = record.sunday_unavailable === 1;
            }
            
            // 填充固定班次信息
            if (record.type === 'fixed' && record.schedules && record.schedules.length > 0) {
                // 清空现有数据
                this.table.data = [];
                record.schedules.forEach((schedule, index) => {
                    // 解析schedule_at为日期和时间
                    let date = null;
                    let time = moment('10:00', 'HH:mm');
                    
                    if (schedule.schedule_at) {
                        try {
                            // 先尝试解析整个schedule_at字符串为moment对象
                            const scheduleMoment = moment(schedule.schedule_at);
                            if (scheduleMoment.isValid()) {
                                // 分离日期和时间
                                date = scheduleMoment;
                                time = moment(scheduleMoment, 'YYYY-MM-DD HH:mm');
                            } else {
                                // 尝试用split方法解析
                                const [dateStr, timeStr] = schedule.schedule_at.split(' ');
                                if (dateStr) {
                                    const dateMoment = moment(dateStr);
                                    date = dateMoment.isValid() ? dateMoment : moment();
                                }
                                if (timeStr) {
                                    const timeMoment = moment(timeStr, 'HH:mm');
                                    if (timeMoment.isValid()) {
                                        time = timeMoment;
                                    }
                                }
                            }
                        } catch (error) {
                            console.error('解析schedule_at失败:', error);
                        }
                    }
                    
                    this.table.data.push({
                        id: schedule.id,
                        index: index,
                        date: date,
                        time: time,
                        teachers: schedule.teachers || [],
                        duration: schedule.duration || '',
                        people: schedule.max_count || '',
                        teacher_ids: (schedule.teachers || []).map(t => t.id),
                        openTime: false // 每个班次独立的时间选择器状态
                    });
                });
            } else if (record.type === 'fixed') {
                // 如果是固定班次模式但没有schedules数据，确保有一行默认数据
                this.table.data = [{
                    index: 0,
                    date: null,
                    time: null,
                    teachers: [],
                    duration: '',
                    people: '',
                    openTime: false
                }];
            }
            
            // 如果有不可预约时间段（支持unavailable_dates格式）
            if (record.unavailable_dates && record.unavailable_dates.length > 0) {
                this.unavailable_times = record.unavailable_dates.map(timeRange => {
                    // 从二维数组中获取开始和结束时间字符串
                    const [startDateTime, endDateTime] = timeRange;
                    
                    // 解析开始时间
                    let startDate = moment();
                    let startTime = '09:00';
                    if (startDateTime) {
                        const [startDateStr, startTimeStr] = startDateTime.split(' ');
                        if (startDateStr && moment(startDateStr).isValid()) {
                            startDate = moment(startDateStr);
                        }
                        if (startTimeStr) {
                            startTime = startTimeStr;
                        }
                    }
                    
                    // 解析结束时间
                    let endDate = moment();
                    let endTime = '18:00';
                    if (endDateTime) {
                        const [endDateStr, endTimeStr] = endDateTime.split(' ');
                        if (endDateStr && moment(endDateStr).isValid()) {
                            endDate = moment(endDateStr);
                        }
                        if (endTimeStr) {
                            endTime = endTimeStr;
                        }
                    }
                    
                    return {
                        start_date: startDate,
                        start_time: startTime,
                        end_date: endDate,
                        end_time: endTime,
                        startOpen: false,
                        endOpen: false
                    };
                });
            } else if (record.unavailable_times && record.unavailable_times.length > 0) {
                // 保持原有格式的兼容性
                this.unavailable_times = record.unavailable_times.map(time => ({
                    start_date: time.start_date ? (moment(time.start_date).isValid() ? moment(time.start_date) : moment()) : moment(),
                    start_time: time.start_time || '09:00',
                    end_date: time.end_date ? (moment(time.end_date).isValid() ? moment(time.end_date) : moment()) : moment(),
                    end_time: time.end_time || '18:00',
                    startOpen: false,
                    endOpen: false
                }));
            }
        },
        
        // 重置表单
        resetForm() {
            this.params = {
                name: '',
                type: 'flexible'
            };
            this.flexibleTeachers = [];
            this.tempSelectedTeachers = [];
            this.available_times = [{ start_time: '09:00', end_time: '18:00', startOpen: false, endOpen: false }];
            this.unavailable_times = [];
            this.saturday_unavailable = false;
            this.sunday_unavailable = false;
            this.holiday_unavailable = false;
            this.table.data = [{
                index: '0',
                date: null,
                time: null,
                teachers: [],
                duration: '',
                people: '',
                openTime: false // 每个班次独立的时间选择器状态
            }];
        },
        close() {
            this.visible = false;
            this.showTeacherList = false;
            // 重置随用随约模式下的老师选择
            this.flexibleTeachers = [];
            // 重置临时选择列表
            this.tempSelectedTeachers = [];
        },
        handleCheckboxChange(field) {
            this[field] = !this[field];
        },
        addUnavailableTime() {
            const today = moment().format('YYYY-MM-DD');
            this.unavailable_times.push({
                start_date: moment(today), // 使用moment对象而不是字符串
                start_time: '09:00',
                end_date: moment(today), // 使用moment对象而不是字符串
                end_time: '18:00',
                startOpen: false,
                endOpen: false
            })
        },
        
        handleUnavailableStartTimeChange(item, time) {
            if (time) {
                item.start_time = time.format('HH:mm');
            }
        },
        
        handleUnavailableEndTimeChange(item, time) {
            if (time) {
                item.end_time = time.format('HH:mm');
            }
        },
        
        removeUnavailableTime(index) {
            this.unavailable_times.splice(index, 1);
        },
        
        formatUnavailableTime(item) {
            // 确保日期和时间都有值
            const startDate = item.start_date && moment.isMoment(item.start_date) ? item.start_date.format('YYYY-MM-DD') : '';
            const startTime = item.start_time || '00:00';
            const endDate = item.end_date && moment.isMoment(item.end_date) ? item.end_date.format('YYYY-MM-DD') : '';
            const endTime = item.end_time || '00:00';
            
            return `${startDate} ${startTime} - ${endDate} ${endTime}【不可预约】`;
        },
        save() {
            // 检查必填字段
            if (!this.params.name) {
                this.$message.error('请输入项目名称');
                return;
            }

            // 构建请求参数
            const requestData = {
                name: this.params.name,
                type: this.params.type
            };
            
            // 如果是编辑模式，添加ID
            if (this.isEditMode && this.editRecordId) {
                requestData.id = this.editRecordId;
            }

            // 随用随约模式下添加老师信息
            if (this.params.type === 'flexible' && this.flexibleTeachers.length > 0) {
                requestData.teacher_ids = this.flexibleTeachers.map(t => t.id);
            }

            // 处理固定班次数据 - 按照指定格式
            if (this.params.type === 'fixed') {
                requestData.schedules = [];
                this.table.data.forEach(item => {
                    if (item.date && item.teachers && item.teachers.length > 0 && item.duration) {
                        // 构建schedule_at时间字符串：日期+时间
                        // 更健壮的处理：检查类型并使用moment格式化
                        const dateStr = item.date ? (typeof item.date === 'string' ? item.date : moment(item.date).format('YYYY-MM-DD')) : '';
                        const timeStr = item.time ? (typeof item.time === 'string' ? item.time : moment(item.time).format('HH:mm')) : '10:00';
                        const scheduleAt = `${dateStr} ${timeStr}`;
                        console.log('scheduleAt', scheduleAt);
                        let obj = {
                            teacher_ids: item.teachers.map(t => t.id),
                            schedule_at: scheduleAt,
                            duration: item.duration, // 时长（分钟）
                            max_count: item.people ? parseInt(item.people) : 1 // 最大预约人数
                        };
                        if (item.id) {
                            obj.id = item.id;
                        }
                        requestData.schedules.push(obj);
                    }
                });
            }

            // 处理随用随约模式的时间段数据
            if (this.params.type === 'flexible' && this.params.duration) {
                requestData.duration = this.params.duration;
                requestData.available_times = this.available_times.map(time => [
                    time.start_time,
                    time.end_time
                ]);
                requestData.saturday_unavailable = this.saturday_unavailable?1:0;
                requestData.sunday_unavailable = this.sunday_unavailable?1:0;
            }
            
            // 处理不可预约时间字段，转换为要求的格式
            if (this.unavailable_times && this.unavailable_times.length > 0) {
                requestData.unavailable_dates = this.unavailable_times.map(time => {
                    // 构建开始时间字符串：日期+时间
                    const startDateStr = time.start_date && moment.isMoment(time.start_date) ? time.start_date.format('YYYY-MM-DD') : '';
                    const startTimeStr = time.start_time || '00:00';
                    const startDateTime = `${startDateStr} ${startTimeStr}`;
                    
                    // 构建结束时间字符串：日期+时间
                    const endDateStr = time.end_date && moment.isMoment(time.end_date) ? time.end_date.format('YYYY-MM-DD') : '';
                    const endTimeStr = time.end_time || '00:00';
                    const endDateTime = `${endDateStr} ${endTimeStr}`;
                    
                    return [startDateTime, endDateTime];
                });
            }
            
            // 调用接口
            api.post('/ast-appointment/appointment-sync', requestData).then(res => {
                if (res.code === 0) {
                    this.$message.success('已成功保存，手机端须重新进入小程序方可生效')
                    this.close();
                    // 触发保存成功事件，通知父组件刷新列表
                    this.$emit('save-success');
                } else {
                    this.$message.error(res.msg || '保存失败');
                }
            }).catch(() => {
                this.$message.error('网络异常，请重试');
            });
        },
        // 显示老师选择列表
        showTeacherSelect(row) {
            // 检查是否点击的是同一个行且列表已显示，如果是则收起弹窗
            if (this.currentRow && this.currentRow.index === row.index && this.showTeacherList) {
                this.showTeacherList = false;
                return;
            }

            this.currentRow = row;
            // 初始化临时选择列表为当前行已选择的老师
            this.tempSelectedTeachers = row.teachers ? [...row.teachers] : [];
            this.showTeacherList = true;
        },

        // 随用随约模式下选择老师
        selectFlexibleTeachers() {
            // 清除当前行标记，表示正在处理随用随约模式的老师选择
            this.currentRow = null;
            // 初始化临时选择列表为当前已选择的老师
            this.tempSelectedTeachers = [...this.flexibleTeachers];
            this.showTeacherList = true;
        },
        // 获取老师列表
        getTeachers() {
            const params = {
                page: 1,
                pageSize: 100
            };
            api.get('/ast-appointment/teacher-list', params).then(res => {
                if (res.code === 0) {
                    this.teachers = res.data.data || [];
                }
            }).catch(() => {
                this.$message.error('获取老师列表失败');
            })
        },
        // 选择老师
        selectTeacher(teacher) {
            // 无论哪种模式，都更新临时选择列表
            const teacherIndex = this.tempSelectedTeachers.findIndex(t => t.id === teacher.id);
            if (teacherIndex > -1) {
                // 如果已选择，则取消选择
                this.tempSelectedTeachers.splice(teacherIndex, 1);
            } else {
                // 如果未选择，则添加到已选择列表
                this.tempSelectedTeachers.push({
                    id: teacher.id,
                    name: teacher.name,
                    avatar: teacher.avatar
                });
            }
        },
        // 检查老师是否已选中
        isTeacherSelected(teacher) {
            // 检查临时选择列表而不是实际数据
            return this.tempSelectedTeachers.some(t => t.id === teacher.id);
        },
        // 确认选择老师
        confirmTeacherSelection() {
            if (this.currentRow) {
                // 固定班次模式下的处理
                const rowData = this.table.data[this.currentRow.index];
                // 点击确定后，才将临时选择应用到实际数据
                rowData.teachers = [...this.tempSelectedTeachers];
                // 更新教师ID列表
                rowData.teacher_ids = rowData.teachers.map(t => t.id);
            } else {
                // 随用随约模式下的处理
                this.flexibleTeachers = [...this.tempSelectedTeachers];
            }
            this.showTeacherList = false;
        },
        // 关闭老师选择列表
        closeTeacherList() {
            this.showTeacherList = false;
        },

        // 删除随用随约模式下已选择的老师
        removeFlexibleTeacher(teacher) {
            const index = this.flexibleTeachers.findIndex(t => t.id === teacher.id);
            if (index > -1) {
                this.flexibleTeachers.splice(index, 1);
            }
        },
        
        // 移除不可预约时间段
        removeAvailableTime(index) {
            // 确保至少保留一个时间段
            if (this.available_times.length > 1) {
                this.available_times.splice(index, 1);
            } else {
                this.$message.warning('至少需要保留一个开放时间段');
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.project-create {
    /deep/ .ant-drawer-body {
        padding: 0;
    }

    /deep/ .ant-table-body {
        margin: 0;
    }

    /deep/ .ant-table-tbody>tr>td,
    /deep/ .ant-table-thead>tr>th {
        height: 40px;
        padding: 0 !important;
    }

    /deep/ .ant-drawer-wrapper-body,
    /deep/ .ant-drawer-content {
        overflow: visible;
    }

    input {

        border: none;
        outline: none;
        padding: 0;
        margin: 0;

        &::placeholder {
            color: rgba(0, 0, 0, 0.25);
        }
    }

    .wrapper {
        height: 100vh;
        background: #FFFFFF;
        padding-top: 24px;
        display: flex;
        flex-direction: column;
        position: relative;

        .tearcher-list {
            width: 212px;
            height: 100%;
            display: flex;
            align-items: center;
            justify-content: center;
            position: absolute;
            top: 0;
            left: -212px;
            z-index: 100;

            .container {
                width: 212px;
                max-height: 600px;
                background: linear-gradient(137deg, #F5F8FF 0%, #FFFFFF 42%, #F5F8FF 100%);
                box-shadow: 0 0 10px 0 rgba(29, 61, 123, 0.2);
                padding: 16px;
                box-sizing: border-box;

                .tearcher-items {
                    height: 490px;
                    overflow-y: auto;
                }

                .buttons-container {
                    width: 180px;
                    height: 76px;
                    margin: 0 auto;
                    margin-top: 16px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    border-top: 1px solid #EEEEEE;
                }

                .btn {
                    width: 72px;
                    height: 32px;
                    background: #333333;
                }

                .btn-close {
                    width: 74px;
                    height: 34px;
                    line-height: 34px;
                    background: #FFFFFF;
                    border: 1px solid #333333;
                    cursor: pointer;
                    color: #333333;
                    font-size: 14px;
                    margin-left: 16px;

                    &:hover {
                        background: #eeeeee;
                    }
                }

                .tearcher-item {
                    width: 100%;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    margin-top: 16px;
                    cursor: pointer;
                    transition: all 0.3s;
                    padding: 8px 0;

                    &:hover {
                        border: 1px solid #1D3D7B;
                    }

                    .checkbox-container {
                        margin-right: 16px;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                    }

                    .checkbox-unchecked {
                        width: 16px;
                        height: 16px;
                        border-radius: 2px;
                        border: 1px solid #D9D9D9;
                        box-sizing: border-box;
                    }

                    .checkbox-checked {
                        width: 16px;
                        height: 16px;

                        img {
                            width: 100%;
                            height: 100%;
                        }
                    }

                    .avatar {
                        width: 56px;
                        height: 56px;
                        border-radius: 50%;
                        margin-right: 12px;
                    }

                    span {
                        font-size: 14px;
                        color: #333333;
                    }
                }
            }
        }

        .at-title-create {
            width: 199px;
            height: 54px;
            background: url("/assets/icons/project-create-title.png") no-repeat;
            background-size: 199px 54px;
            margin-left: 32px;
        }

        .at-title {
            height: 54px;
        }

        .sd-footer {
            width: 100%;
            height: 64px;
            background: #FFFFFF;
            box-shadow: 0px -1px 8px 0px rgba(0, 0, 0, 0.12);
            padding: 16px 32px;
            box-sizing: border-box;
        }
    }

    .body-scroll {
        flex: 1;
        padding: 40px 32px 0;

        .item {
            margin-bottom: 24px;

            .option-box {
                width: 100%;
                height: 100%;
                display: flex;
                align-items: center;
                padding: 0 8px;
                box-sizing: border-box;
                cursor: pointer;
                
                &.date-box {
                    justify-content: center;
                    gap: 10px;
                    
                    .ant-calendar-picker,
                    .ant-time-picker {
                        flex: 1;
                    }
                    
                    .ant-time-picker {
                        .ant-time-picker-input {
                            height: 32px;
                        }
                    }
                }

                .content {
                    flex: 1;
                    font-size: 14px;
                    color: #333333;
                    text-align: center;
                }

                img {
                    width: 16px;
                    height: 16px;
                }
            }

            .teacher-box {
                img {
                    width: 12px;
                    height: 12px;
                }

                .teacher-avatars {
                    display: flex;
                    align-items: center;
                }

                .avatar-container {
                    position: relative;
                    width: 24px;
                    height: 24px;
                    border-radius: 50%;
                    overflow: hidden;
                    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
                }

                .avatar-container img {
                    width: 100%;
                    height: 100%;
                    object-fit: cover;
                }
            }

            .sub-title {
                margin-bottom: 16px;

                span {
                    color: #333333;
                    font-size: 14px;
                    line-height: 20px;

                    &:first-child {
                        color: #FF2323;
                    }
                }
            }

            .content-wrapper {
                width: 100%;
                height: 40px;
                background: #FFFFFF;
                border: 1px solid #D9D9D9;
                padding: 10px 16px;
                display: flex;
                align-items: center;

                .input {
                    flex: 1;
                    height: 100%;
                    font-size: 14px;
                    color: #333333;
                }

                .input-length {
                    color: rgba(0, 0, 0, 0.25);
                    font-size: 14px;
                    line-height: 20px;
                }

            }

            .time-wrapper {
                margin-bottom: 24px;
            }

            .unavailable-wrapper {
                width: 100%;
                background: #FFFFFF;
                display: flex;
                align-items: center;
                justify-content: space-between;

                .unavailable-row {
                    width: 100%;
                    height: 40px;
                    display: flex;
                    align-items: center;
                    border: 1px solid #e8e8e8;
                    border-bottom: none;
                    padding: 0 16px;
                    box-sizing: border-box;

                    .checkbox-item {
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        margin-right: 32px;
                        cursor: pointer;

                        .checkbox-icon {
                            width: 16px;
                            height: 16px;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            margin-right: 4px;

                            img {
                                width: 100%;
                                height: 100%;
                                vertical-align: middle;
                            }
                        }

                        span {
                            color: #333333;
                            font-size: 14px;
                        }
                    }
                }
            }
            
            .unavailable-time-list {
                .del-box{
                    img{
                        width: 24px;
                        height: 24px;
                    }
                }
            }
            
            .unavailable-time-items {
                background: #FFFFFF;
                border: 1px solid #e8e8e8;
                border-top: none;
                border-bottom: none;
                padding: 16px;
                text-align: center;
            }
            
            .unavailable-time-item {
                color: #FF4D4F;
                font-size: 14px;
                margin-bottom: 8px;
                &:last-child {
                    margin-bottom: 0;
                }
            }

            .add-box {
                width: 100%;
                height: 40px;
                border: 1px solid #e8e8e8;
                display: flex;
                align-items: center;
                justify-content: center;
                cursor: pointer;

                img {
                    width: 16px;
                    height: 16px;
                }

                span {
                    color: #333333;
                    font-size: 14px;
                    margin-left: 8px;
                }
            }

            .flexible-teacher-box {
                margin-bottom: 24px;

                .selected-teachers {
                    display: flex;
                    flex-wrap: wrap;
                    gap: 2px;
                    margin-bottom: 2px;
                }

                .selected-teacher-item {
                    width: calc(50% - 1px);
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    padding: 10px 16px;
                    border: 1px solid #D9D9D9;

                    .teacher-info {
                        flex: 1;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                    }

                    .del-box {
                        width: 24px;
                        height: 24px;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        cursor: pointer;

                        img {
                            width: 100%;
                            height: 100%;
                        }
                    }
                }

                .selected-teacher-item img {
                    width: 24px;
                    height: 24px;
                    border-radius: 50%;
                    margin-right: 8px;
                }
            }

            .table-wrapper {
                width: 100%;

                .add-box {
                    border-top: none;
                }

                input {
                    width: 100%;
                    height: 100%;
                    text-align: center;
                }

                .table-head {
                    color: #333333;
                    font-size: 14px;
                    text-align: center;
                    background: #FFFFFF;
                    line-height: 20px;
                    padding: 10px 0;
                }

                .table-item {
                    color: #333333;
                    font-size: 14px;
                    text-align: center;
                    background: #FFFFFF;
                    line-height: 20px;
                    padding: 10px 0;
                }
            }
        }
    }
}
</style>
